import { Fragment } from "react";
import { Box,  Typography } from "@mui/material";

const Footer = () => {

    const handleTerms = () => {
        const mapUrl = `https://thecourierguy.co.za/terms-conditions`;
        window.open(mapUrl, "_blank");
    }

    return <Fragment>
        <Box
            sx={{
                backgroundColor: "#868686",
                height: "5vh",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                position: "fixed",
                bottom: 0,
                width: "100%",
                zIndex: 998,
            }}
        >
            <Typography
                color={"#ffffff"}
                onClick={() => handleTerms()}
                sx={{ cursor: "pointer" }}
            >
                Terms and Conditions
            </Typography>
        </Box>
    </Fragment>
}

export default Footer;